/* Bathmate product page buy box: variant buttons and the phone sticky Add
   to Cart bar. Loaded on product templates (layout/theme.liquid).

   Variant buttons (snippets/product-form.liquid, data-bm-variant-picker):
   a click sets Turbo's own (hidden) option dropdown and fires "change",
   so Shopify's option selector updates the variant id, price, Shop Pay
   installments, ?variant= in the URL, the image and the Add to Cart state
   exactly as before. Values with no available variant are disabled.

   Sticky bar (snippets/bathmate-product-sticky-atc.liquid): phones only,
   while the main Add to Cart is out of view and the footer isn't; its
   button presses the main Add to Cart, and it mirrors the main button's
   label / disabled state, the selected variant, price and image. */
(function () {
  'use strict';

  function moneyFormat() {
    var f = document.body.getAttribute('data-money-format');
    return f ? f.trim() : '${{amount}}';
  }

  function money(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat());
      }
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }

  function productData(el) {
    var wrap = el && el.closest('[data-product]');
    if (!wrap) return null;
    try {
      return JSON.parse(wrap.getAttribute('data-product'));
    } catch (e) {
      return null;
    }
  }

  function variantFor(product, values) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var match = true;
      for (var k = 0; k < values.length; k++) {
        if (v.options[k] !== values[k]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  // A value is offered when an available variant has it together with the
  // values chosen for the options before it.
  function availableWith(product, values, index, value) {
    return product.variants.some(function (v) {
      if (!v.available || v.options[index] !== value) return false;
      for (var k = 0; k < index; k++) {
        if (v.options[k] !== values[k]) return false;
      }
      return true;
    });
  }

  /* ---------------- Variant buttons ---------------- */
  function initPicker(picker) {
    if (picker.getAttribute('data-bm-ready')) return;
    picker.setAttribute('data-bm-ready', '1');
    var form = picker.closest('form');
    var product = productData(picker);
    if (!form || !product) return;
    var idSelect = form.querySelector('select[name="id"]');
    var buttons = Array.prototype.slice.call(picker.querySelectorAll('[data-bm-option-index]'));
    var optionCount = product.options.length;

    function turboSelects() {
      return form.querySelectorAll('.single-option-selector');
    }

    function currentValues() {
      var sels = turboSelects();
      if (sels.length) return Array.prototype.map.call(sels, function (s) { return s.value; });
      var v = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(idSelect && idSelect.value)) { v = product.variants[i]; break; }
      }
      return v ? v.options.slice() : [];
    }

    function sync() {
      var values = currentValues();
      buttons.forEach(function (btn) {
        var i = parseInt(btn.getAttribute('data-bm-option-index'), 10);
        var value = btn.getAttribute('data-bm-value');
        var selected = values[i] === value;
        var ok = availableWith(product, values, i, value);
        btn.classList.toggle('is-selected', selected);
        btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
        btn.disabled = !ok;
        var soldOut = btn.querySelector('.bm-variant-btn__soldout');
        if (soldOut) soldOut.hidden = ok;
      });
    }

    function choose(index, value) {
      var values = currentValues();
      values[index] = value;
      // Later options: keep the current value if it still makes an
      // available variant, else take the first one that does.
      for (var i = index + 1; i < optionCount; i++) {
        if (!availableWith(product, values, i, values[i])) {
          var opt = product.options_with_values ? product.options_with_values[i] : null;
          var list = opt ? opt.values : product.variants.map(function (v) { return v.options[i]; });
          for (var j = 0; j < list.length; j++) {
            if (availableWith(product, values, i, list[j])) { values[i] = list[j]; break; }
          }
        }
      }
      var sels = turboSelects();
      if (sels.length) {
        for (var k = 0; k < sels.length; k++) {
          if (sels[k].value !== values[k]) {
            sels[k].value = values[k];
            sels[k].dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      } else if (idSelect) {
        var v = variantFor(product, values);
        if (v) {
          idSelect.value = v.id;
          idSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      sync();
    }

    picker.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-bm-option-index]');
      if (!btn || btn.disabled) return;
      choose(parseInt(btn.getAttribute('data-bm-option-index'), 10), btn.getAttribute('data-bm-value'));
    });

    // Turbo's own "change" on the variant id field doesn't bubble.
    form.addEventListener('change', function () { window.setTimeout(sync, 0); });
    if (idSelect) idSelect.addEventListener('change', function () { window.setTimeout(sync, 0); });
    sync();
  }

  /* ---------------- Sticky Add to Cart (phones) ---------------- */
  function initSticky() {
    var bar = document.querySelector('[data-bm-sticky-atc]');
    if (!bar || bar.getAttribute('data-bm-ready')) return;
    var section = document.querySelector('.js-product-section--product') || document;
    var main = section.querySelector('.product_form .add_to_cart');
    if (!main || !('IntersectionObserver' in window)) return;
    bar.setAttribute('data-bm-ready', '1');

    var form = main.closest('form');
    var product = productData(main);
    var idSelect = form ? form.querySelector('[name="id"]') : null;
    var btn = bar.querySelector('[data-bm-sticky-btn]');
    var priceEl = bar.querySelector('[data-bm-sticky-price]');
    var variantEl = bar.querySelector('[data-bm-sticky-variant]');
    var imgEl = bar.querySelector('[data-bm-sticky-img]');
    var phone = window.matchMedia('(max-width: 749px)');
    var mainInView = true;
    var footerNear = false;

    bar.hidden = false;
    bar.setAttribute('aria-hidden', 'true');
    bar.inert = true;

    function update() {
      var show = phone.matches && !mainInView && !footerNear;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.inert = !show;
    }

    new IntersectionObserver(function (entries) {
      mainInView = entries[0].isIntersecting;
      update();
    }).observe(main);

    var footer = document.querySelector('.shopify-section-group-footer-group, footer, #footer, .footer');
    if (footer) {
      new IntersectionObserver(function (entries) {
        footerNear = entries.some(function (e) { return e.isIntersecting; });
        update();
      }, { rootMargin: '0px 0px 120px 0px' }).observe(footer);
    }

    if (phone.addEventListener) phone.addEventListener('change', update);
    else if (phone.addListener) phone.addListener(update);

    // Mirror the main button: label and disabled / sold-out state.
    function mirrorButton() {
      var label = main.querySelector('.text');
      btn.textContent = (label ? label.textContent : main.textContent).trim();
      btn.disabled = main.disabled || main.classList.contains('disabled');
      // Grey only when sold out / unavailable, not during the brief "adding" state.
      var wrap = main.closest('.purchase-details__buttons');
      btn.classList.toggle('is-unavailable', !!(wrap && wrap.classList.contains('product-is-unavailable')));
    }
    new MutationObserver(mirrorButton).observe(main, { attributes: true, childList: true, subtree: true, characterData: true });
    mirrorButton();

    // Variant, price and image from the selected variant.
    function syncVariant() {
      if (!product || !idSelect) return;
      var v = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(idSelect.value)) { v = product.variants[i]; break; }
      }
      if (!v) return;
      if (priceEl) priceEl.innerHTML = money(v.price);
      if (variantEl) {
        variantEl.textContent = v.title;
        variantEl.hidden = v.title === 'Default Title';
      }
      if (imgEl && v.featured_image && v.featured_image.src) {
        var src = v.featured_image.src;
        imgEl.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=120';
      }
    }
    if (form) form.addEventListener('change', function () { window.setTimeout(syncVariant, 0); });
    if (idSelect) idSelect.addEventListener('change', function () { window.setTimeout(syncVariant, 0); });

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      main.click();
    });

    update();
  }

  function init() {
    document.querySelectorAll('[data-bm-variant-picker]').forEach(initPicker);
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
